import React from "react";
import { Box, Text } from "@catchoftheday/cg-components";
import { CurrentBenefit } from "./CurrentBenefit";
import { FreeDelivery } from "./FreeDelivery";
import { PersonalisedOffer } from "./PersonalisedOffer";
export const MobileWrapper = () => {
    return (<Box borderRadius="corner" borderColor="onePass.primaryDarker" borderStyle="solid" borderWidth="1px" overflow="hidden">
      <Box py={5} px={4}>
        <CurrentBenefit />
      </Box>
      <Box p={4} backgroundColor="onePass.primaryDarker" color="white">
        <Text textAlign="center" fontWeight="bold" fontSize="base" m={0}>
          + PLUS
        </Text>
        <Box py={4} borderColor="white" borderStyle="solid" borderWidth={0} borderBottomWidth="1px">
          <FreeDelivery />
        </Box>
        <Box pt={4}>
          <PersonalisedOffer />
        </Box>
      </Box>
    </Box>);
};
